import { Grid } from '@material-ui/core';
import React, { useState } from 'react';

const CookieBanner = () => {
    const [visible, setVisible] = useState(true);

    const handleAccept = () => {
        setVisible(false);
    }

    if (!visible) {
        return null;
    }

    return (
        <Grid container style={{ justifyContent: 'center' }}>
            <Grid style={{
                position: 'fixed',
                bottom: '0',
                width: '100%',
                backgroundColor: 'white',
                boxShadow: '0 -2px 10px rgba(0, 0, 0, 0.1)',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '1rem',
                zIndex: 1000,
                borderRadius: '0.4em',
            }}>

                <p style={{
                    margin: '0.6em',
                    fontSize: '0.9rem'
                }}>
                    Utilizamos cookies e tecnologia para aprimorar sua experiência de navegação de acordo com a
                    <a href="https://cnm.org.br/informe/exibe/politica-de-privacidade" target="_blank" rel="noopener noreferrer" style={{
                        color: '#007bff',
                        textDecoration: 'none',
                        marginLeft: '5px',
                    }}> política de privacidade</a> e
                    <a href="https://cnm.org.br/informe/exibe/politica-de-cookies" target="_blank" rel="noopener noreferrer" style={{
                        color: '#007bff',
                        textDecoration: 'none',
                        marginLeft: '5px',
                    }}> política de cookies</a>.
                </p>
                <button onClick={handleAccept} style={{
                    backgroundColor: '#007bff',
                    color: 'white',
                    border: 'none',
                    padding: '0.5rem 1rem',
                    cursor: 'pointer',
                    fontSize: '0.9rem',
                    borderRadius: '3px',
                    marginRight: '0.9rem'
                }}>ACEITO</button>
            </Grid>

        </Grid>
    );
};


export default CookieBanner;
